// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"error-number\">404</div>\n<p class=\"login-message\">\n  This URL is not mapped to any valid Weka Sizer instance. Please check the URL and contact the Weka team to get the right one.\n</p>";
},"useData":true});
